import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Sparkles, ArrowRight } from 'lucide-react';
import './ClearSense.css';

async function startCheckout(kind) {
  const res = await fetch('/api/clearsense/billing/checkout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ kind, analysisSessionId: '' }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  const { url } = await res.json();
  return url;
}

function ClearSense() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleProCheckout = async () => {
    setError(null);
    setLoading(true);
    try {
      const url = await startCheckout('pro');
      window.location.href = url;
    } catch (err) {
      if (err.message.includes('sign in') || err.message.includes('401') || err.message.includes('logged')) {
        window.location.href = '/signin';
      } else {
        setError('Could not start checkout. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clearsense-page">
      <Helmet>
        <title>ClearSense - AI Answer Sense-Checker | Erasys</title>
        <meta
          name="description"
          content="Check AI-generated answers for logic, consistency, and verifiable claims. Free tier with highlights and claims analysis. Pro tier with source verification."
        />
      </Helmet>

      {/* Embedded ClearSense App — fills full viewport */}
      <div className="clearsense-embed-container">
        <iframe
          src="/clearsense-app"
          title="ClearSense Application"
          className="clearsense-iframe"
          frameBorder="0"
          allowFullScreen
        />
      </div>

      {/* Floating Pro upgrade strip */}
      <div className="cs-pro-strip">
        <div className="cs-pro-strip-inner">
          <Sparkles size={16} className="cs-pro-strip-icon" />
          <span className="cs-pro-strip-text">
            <strong>ClearSense Pro</strong> — Source verification, unlimited exports &amp; full reports
          </span>
          <span className="cs-pro-strip-price">£19.99/mo</span>
          <button
            className="cs-pro-strip-btn"
            onClick={handleProCheckout}
            disabled={loading}
          >
            {loading ? 'Redirecting…' : 'Upgrade to Pro'}
            {!loading && <ArrowRight size={14} />}
          </button>
        </div>
        {error && <p className="cs-pro-strip-error">{error}</p>}
      </div>
    </div>
  );
}

export default ClearSense;
